import { AuthRoutingModule } from './auth-routing.module';
import { SigninComponent } from './signin/signin.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
@NgModule({
    declarations: [
        SigninComponent
    ]
    ,
    imports: [
        RouterModule,
        FormsModule,
        AuthRoutingModule
    ],
    providers: []
})
export class AuthModule {

}



// WEBPACK FOOTER //
// ./src/opc/auth/auth.module.ts